import React, { useState, useEffect } from "react";
import { backendApi } from "../../api/apiService";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BiEditAlt } from "react-icons/bi";
import { error } from "jquery";

function CandidateHistory() {
    const location = useLocation();
    const candidateId = location.pathname.split("/")[2];
    const [historyDetails, setHistoryDetails] = useState([])
    useEffect(() => {
        var req = {
            "functionName": "candidateHistory",
            "candidate_id": candidateId
        };
        backendApi(req).then((response) => {
            if (response.success === "1") {
                console.log(response);
                setHistoryDetails(response.history)
            } else {
                setHistoryDetails([])
            }
        }).catch((error) => {
            console.error("Error sending notification:", error);
            alert("An error occurred while Getting Details");
        });

    }, [])
    function convertToIST(timestamp) {
        const utcDate = new Date(timestamp);
        const offsetMinutes = utcDate.getTimezoneOffset();
        const istOffset = 330;
        
        // Calculate IST time
        const istTime = new Date(utcDate.getTime() + (offsetMinutes + istOffset) * 60 * 1000);
    
        // Format IST time as per custom format (DD/MM/YYYY, HH:mm am/pm)
        const options = {
            day: '2-digit',    // Display day with leading zeros
            month: '2-digit',  // Display month with leading zeros
            year: 'numeric',   // Display full year
            hour: '2-digit',   // Display hour in 12-hour format with leading zeros
            minute: '2-digit', // Display minutes with leading zeros
            hour12: true       // Use 12-hour clock (am/pm)
        };
    
        const istTimeString = istTime.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata', ...options });
    
        return istTimeString;
    }
    
    // function convertToIST(timestamp) {
    //     const utcDate = new Date(timestamp);
    //     const offsetMinutes = utcDate.getTimezoneOffset();
    //     const istOffset = 330;
    //     const istTime = new Date(utcDate.getTime() + (offsetMinutes + istOffset) * 60 * 1000);
    //     const istTimeString = istTime.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });
    //     return istTimeString;
    // }
    return (
        <div className="cardDeatils">
            <ToastContainer
                enableMultiContainer
                containerId={"K"}
                position="bottom-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
            <div className="outer-timeline">
                {historyDetails.length > 0 ? (
                    historyDetails.map((data, index) => (
                        <div className="inner-timeline" key={index}>
                            <div className="sub-timeline">
                                <div className="sub-left-timeline">
                                    <BiEditAlt />
                                </div>
                                <div className="sub-right-timeline">
                                    <div className="timeline-head">{convertToIST(data.date_time)} </div>
                                    {data.history && <div className="timeline-time">{data.history}</div>}
                                    {data.jobSummary &&
                                        <div className="timeline-details">
                                            <div className="timeline-para">{data.jobSummary}</div>
                                        </div>
                                    }
                                    {data.created_by && <div className="timeline-name">Created By: {data.created_by}</div>}

                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="centered-container">
                        <p className="centered-text">No data Found</p>
                    </div>
                )}
            </div>
        </div>
    );
}
export default CandidateHistory;
